export default function getLoanNumber(loan) {
  if (loan?._lender?.pref_use_lender_loan_numbers) {
    return loan.loan_number || loan.pixel_loan_number;
  }
  return loan.pixel_loan_number;
}
